import React, { useState } from "react";
import { Logo } from "./Logo";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Lattes", href: "#lattes" },
  { label: "About", href: "#about" },
  { label: "Pop-ups", href: "#popups" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-md bg-[#FAF9F6]/80 border-b border-[#E8E3DD]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <a href="#top" data-testid="header-logo-link" className="flex items-center">
          <Logo testId="header-logo" />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              href={l.href}
              className="text-sm tracking-wide text-[#5C4E46] hover:text-[#2C1E16] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            data-testid="nav-join-cta"
            href="#contact"
            className="text-sm font-medium bg-[#2C1E16] text-[#FAF9F6] hover:bg-[#3E2D24] transition-colors rounded-full px-5 py-2.5"
          >
            Join List
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((s) => !s)}
          className="md:hidden p-2 -mr-2 text-[#2C1E16]"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[#E8E3DD] bg-[#FAF9F6]">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#2C1E16] text-base"
              >
                {l.label}
              </a>
            ))}
            <a
              data-testid="mobile-nav-join-cta"
              href="#contact"
              onClick={() => setOpen(false)}
              className="text-center bg-[#2C1E16] text-[#FAF9F6] rounded-full px-5 py-3 mt-2"
            >
              Join List
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
